import AttendanceAdapter from './base';

export default class Register extends AttendanceAdapter {
  modelNamePlural = 'registers';
}
